import { Colors } from '@zep/ui-tokens';

export const businessQueryKeys = {
  PAYMENT_ORDER_ID: 'get-business-payment-order-id',
  CHECK_PAYMENT_HASH_ID: 'check-payment-hash-id',
  CHECK_PAYMENT_PERMISSION: 'check-payment-permission',
  GET_PAYMENT_RESULT: 'get-payment-result',
};

export const singularSubscriptionQueryKeys = {
  PAYMENT_ORDER_ID: 'get-singular_subscription-payment-order-id',
  CHECK_PAYMENT_HASH_ID: 'check-singular_subscription-payment-hash-id',
  CHECK_PAYMENT_PERMISSION: 'check-singular_subscription-payment-permission',
  GET_PAYMENT_RESULT: 'get-singular_subscription-payment-result',
};

export const CreditCardList: Record<string, string> = {
  '3K': '기업 비씨',
  '46': '광주은행',
  '71': '롯데카드',
  '30': 'KDB산업은행',
  '31': '비씨카드',
  '51': '삼성카드',
  '38': '새마을금고',
  '41': '신한카드',
  '62': '신협',
  '36': '씨티카드',
  '33': '우리카드',
  '37': '우체국예금보험',
  '39': '저축은행중앙회',
  '35': '전북은행',
  '42': '제주은행',
  '15': '카카오뱅크',
  '3A': '케이뱅크',
  '24': '토스뱅크',
  '21': '하나카드',
  '61': '현대카드',
  '11': 'KB국민카드',
  '91': 'NH농협카드',
  '34': 'Sh수협은행',
};

export const PLAN_TYPE_STYLES: Record<
  string,
  { bg: string; text: string; fill: string }
> = {
  BASIC: {
    bg: 'bg-mintBg',
    text: 'text-mintDark-hover',
    fill: Colors.MintDarkHover,
  },
  PRO: {
    bg: 'bg-primaryBg',
    text: 'text-primary',
    fill: Colors.PrimaryDefault,
  },
  ENTERPRISE: {
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    fill: Colors.Gray600,
  },
};

export const FreePlan = {
  EDU_ORIGINAL_CCU: 20,
};

export const BasicPlan = {
  MAX_AVAILABLE_CCU: 1000,
  NORMAL_MIN_AVAILABLE_CCU: 30,
  EDU_MIN_AVAILABLE_CCU: 100,
};

export const ProPlan = {
  MAX_AVAILABLE_CCU: 1000,
};
